import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { ONR_CwrRailLayingAndDistressingRecordSchema } from "./ONR_CwrRailLayingAndDistressingRecordSchema";

const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { location, user, date, formSummary, isMaintenance } = reportData;
  if (!formSummary) formSummary = {};

  let data = {
    location: location,
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
  };

  let reportTitle=reportData.isMaintenance ? "MR Number" : "Title"
  let formValue=reportData.isMaintenance ?  reportData.formSummary && reportData.formSummary.formId ? reportData.formSummary.formId : null : "N/A"

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="CWR Rail Laying and Destressing Record" {...props} centerTitle={true} isMaintenance={isMaintenance} />
      <ReportInfoSection
        centered={true}
        titleWidthOverride={{
          col1: "130px",
          col2: "130px",
        }}
        rows={[
          {
            col1: {
              title: reportTitle,
              value: reportData.title,
            },
            col2: {
              title: "Form ID",
              value: formValue
            },
          },

          {
            col1: {
              title: "Location",
              value: data.location,
            },
            col2: {
              title: "Date",
              value: data.reportDate,
            },
          },
          {
            col1: {
              title: "Start Mile Post",
              value: data.smile,
            },
            col2: {
              title: "End Mile Post",
              value: data.emile,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <table className="table-bordered">
        {ONR_CwrRailLayingAndDistressingRecordSchema.sections.map((section) => {
          return <ReportTableSectionRenderer section={section} rowsData={data.crladr} />;
        })}
      </table>
    </div>
  );
};

const ONR_CwrRailLayingAndDistressingRecord = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;

  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["onr_m_cwrRailLayingAndDestressingForm"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["onr_i_cwrRailLayingAndDestressingForm"]);

  const additionalReportParams = {
    location: isMaintenance ? ReportGeneratorUtils.getMaintenanceLocation(inspec) : ReportGeneratorUtils.getInspectionLocation(inspec),
    date: ReportGeneratorUtils.getInspectionDate(inspec),
    user: ReportGeneratorUtils.getInspectionUser(inspec),
    isMaintenance: isMaintenance,
  };

  return formSummaries.map((summary, _i) => (
    <ReportView
      {...props}
      reportData={{
        formSummary: summary,
        title: title,
        ...additionalReportParams,
      }}
    />
  ));
};

export default ONR_CwrRailLayingAndDistressingRecord;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/CwrRailLayingAndDistressingRecord/index.jsx